import { render, staticRenderFns } from "./CSPremiumAnalysis2.vue?vue&type=template&id=4ed03342&"
import script from "./CSPremiumAnalysis2.vue?vue&type=script&lang=js&"
export * from "./CSPremiumAnalysis2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports